module.exports = __webpack_public_path__ + "img/applyWaitingSing.50f67596.gif";